package com.mgacreative.hotel.feature.reservation.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.domain.model.Reservation
import com.mgacreative.hotel.domain.model.Room
import com.mgacreative.hotel.domain.repository.ReservationRepository
import com.mgacreative.hotel.domain.repository.RoomRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlinx.datetime.*

data class CalendarState(
    val rooms: List<Room> = emptyList(),
    val reservations: List<Reservation> = emptyList(),
    val dates: List<LocalDate> = emptyList(),
    val isLoading: Boolean = false,
    val error: String? = null
)

class CalendarViewModel(
    private val roomRepository: RoomRepository,
    private val reservationRepository: ReservationRepository
) : ViewModel() {

    private val _state = MutableStateFlow(CalendarState())
    val state: StateFlow<CalendarState> = _state.asStateFlow()

    init {
        loadCalendarData()
    }

    private fun loadCalendarData() {
        viewModelScope.launch {
            _state.value = _state.value.copy(isLoading = true, error = null)
            
            try {
                // Generate next 30 days starting from today
                val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date
                val dates = (0..30).map { today.plus(it, DateTimeUnit.DAY) }
                
                val rooms = roomRepository.getRooms().sortedBy { it.roomNumber }
                val reservations = reservationRepository.getReservations()
                
                _state.value = _state.value.copy(
                    rooms = rooms,
                    reservations = reservations,
                    dates = dates,
                    isLoading = false
                )
            } catch (e: Exception) {
                _state.value = _state.value.copy(
                    isLoading = false,
                    error = e.message
                )
            }
        }
    }
}
